import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GlobalService } from '../services/global.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	constructor(
		public jwtHelper: JwtHelperService,
		public globalService: GlobalService
	) { }

	public isAuthenticated() {
		let stringValue = localStorage.getItem('isLoggedIn') ? localStorage.getItem('isLoggedIn') : false;
		let accessToken = localStorage.getItem('token') ? localStorage.getItem('token') : false;
		let dependentAccessToken = localStorage.getItem('dependentToken') ? localStorage.getItem('dependentToken') : false;
		const isLoggedIn = (stringValue == "true");

		this.globalService.tokens = accessToken;
		this.globalService.dependentTokens = dependentAccessToken;
		this.globalService.isLoggedIn = isLoggedIn;

		if (!isLoggedIn) {
			return false;
		}

		if (dependentAccessToken) {
			return !this.jwtHelper.isTokenExpired(dependentAccessToken);
		}

		if (accessToken) {
			return !this.jwtHelper.isTokenExpired(accessToken);
		}

		// ✅ ALWAYS return boolean
		return false;
	}
}